import { render, staticRenderFns } from "./TopNavigation.vue?vue&type=template&id=0154aaf6&scoped=true"
import script from "./TopNavigation.vue?vue&type=script&lang=js"
export * from "./TopNavigation.vue?vue&type=script&lang=js"
import style0 from "./TopNavigation.vue?vue&type=style&index=0&id=0154aaf6&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0154aaf6",
  null
  
)

export default component.exports